// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__c0yVp","label":"accordion_label__j-8g8","arrow":"accordion_arrow__MNkr+","reversed":"accordion_reversed__zuo8J"};